import peopleData from "./people.json";

export const postdocs = peopleData.postdocs;
export const phds = peopleData.phds;
export const masters = peopleData.masters;
export const alumni = peopleData.alumni;
export const ras = peopleData.RA;
